import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import LinkCell from "../../../components/grid/linkCell";
import { editClientData, getSyncClient, runCrons, allCompanies } from "../../../store/actions";
import { clientPermissionsList } from '../../../utils/constants';
import './style.scss';
import RightSidebarView from "./Clients-setup"
import { isEqual, sortBy } from 'lodash';


class ClientsView extends Component {
  filterData = [];
  filterData1 = [];
  cronsList = [
    "syncCostCenters",
    "syncEarningCodes",
    "syncDeductionSettings",
    "syncLatestPayrolls",
    "syncEins"
  ];
  state = {
    loading: false,
    selectedRowData: "",
    isShow: false,
    filterPermission: "",
    reportList: [],
    cronJob: "",
    columnDefs: [
      {
        headerName: "Company Name",
        field: "companyName",
        sortable: true,
        filterParams: {
          values: params => {
            const values = this.filterData;
            params.success(values);
          }
        }, flex: 1,

      },
      {
        headerName: "Company Short Name",
        field: "companyShortName",
        sortable: true,
        resizable: true,
        filterParams: {
          values: params => {
            const values = this.filterData1;
            params.success(values);
          }
        }, flex: 1,

      },
      {
        headerName: "Team Support",
        field: "teamSupportRegistration",
        sortable: true,
        filter: false,
        resizable: true,
        flex: 1,
      },
      {
        headerName: "Type",
        field: "companyType",
        sortable: false,
        filter: false,
        resizable: true,
        flex: 1,
      },
      {
        headerName: "Locked",
        field: "locked",
        sortable: false,
        filter: false,
        resizable: true,
        flex: 1,
      },
      {
        headerName: "Is Multi EIN",
        field: "isMultiEIN",
        sortable: true,
        filter: false,
        resizable: true,
        flex: 1
      },
      {
        headerName: "Is HR",
        field: "isHR",
        sortable: true,
        filter: false,
        resizable: true,
        flex: 1
      },
    ],
    rowData: [],
  };

  companyFilters = {
    includeLocked: false,
    permission: "",
    searchInput: ""
  };

  frameworkComponents = {
    cellButton: LinkCell
  };

  async componentDidMount() {
    if (!this.props.CompaniesReducer.length) {
      await this.props.allCompanies();
    };
    let data = clientPermissionsList;
    this.setState({ reportList: data, rowData: this.setRowData() });
  }

  setRowData = () => {
    let { includeLocked, permission, searchInput } = this.companyFilters;
    searchInput = searchInput.toLowerCase()
    let rowData = this.props.CompaniesReducer;
    if (rowData?.length) rowData = rowData.filter(c => {
      let { locked, companyShortName, companyName, permissions } = c;
      let permissionFilter = permission ? permissions.find(per => per.key === permission) : true;
      let searchFilter = searchInput ? (companyShortName.toLowerCase().includes(searchInput) ||
        companyName.toLowerCase().includes(searchInput)) : true;
      let lockedFilter = includeLocked ? true : locked !== true;
      return permissionFilter && searchFilter && lockedFilter;
    });
    return sortBy(rowData, "companyShortName");
  }

  isPermission = perms => {
    let { permissions } = this.props.UserReducer;
    return permissions.find(p => p.key === perms);
  };

  onSelectCronJob = cronJob => {
    this.setState({ cronJob })
  };

  runCronJob = async () => {
    await this.props.runCrons(this.state.cronJob);
    this.setState({ cronJob: "" });
  };

  onGridReady = params => {
    params.api.addGlobalListener((type, e) => {
      if (type === "rowClicked" && this.isPermission("EDIT_SETTING_OR_PERMISSION")) {
        this.EditUserF(e.data);
      }
    });
  }
  searchInput = (e) => {
    this.companyFilters.searchInput = e.target.value;
    this.setState({ rowData: this.setRowData() });

  }

  loadingData = () => {
    this.setState({ loading: true });
    //this is sync api for company
    this.props.getSyncClient();
    this.setState({ loading: false });
  };

  async EditUserF(event) {
    await this.props.editClientData(event);
    this.setState({ isShow: true });
    this.setState({ selectedRowData: event })
  };

  toggleLocked = (e) => {
    this.companyFilters.includeLocked = e.target.checked;
    this.setState({ rowData: this.setRowData() });
  };

  closeSidebar = () => {
    this.setState({ isShow: false });
  }

  filterByPermission = (e) => {
    this.companyFilters.permission = e.target.value;
    this.setState({ rowData: this.setRowData(), filterPermission: e.target.value });
  };

  async componentDidUpdate(prev, prevState) {

    /* if (isEqual(prevState.selectedRowData,) && !isEmpty(this.props.ClientDataReducer) && !isEmpty(this.props.CompaniesReducer)) {
      const companyList = this.props.CompaniesReducer;
      let getCompany = companyList.find(res => res.companyShortName === this.props.ClientDataReducer.companyShortName || res.companyShortName === this.props.UserReducer.company);
      this.setState({ isShow: true });
      this.setState({ selectedRowData: getCompany });
      let data = JSON.parse(localStorage.getItem("USER"));
      delete data['companyId'];
      //delete this.props.UserReducer['companyId']
      localStorage.setItem('USER', JSON.stringify(data));
    }; */
    if (!prev.CompaniesReducer.length && this.props.CompaniesReducer.length) this.setState({ rowData: this.setRowData() });
  };

  render() {

    const { loading, isShow, rowData } = this.state;
    return (

      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <h4 className="heading_h4"> Clients </h4>
          <button className=" fs12 primary mini align-left sync-now-btn py-1 px-4Run Tool Now" onClick={this.loadingData}>
            {loading ? <span>Loading data </span> : <span>Sync Now</span>}
          </button>
        </div>

        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">

            <div className='d-flex align-content-center align-items-center'>
              <div className="filter-field d-flex">
                <input type="text" placeholder="Search" autoFocus onChange={this.searchInput} />
              </div>
              <div className="filter-field d-flex align-items-center">
                <input type="checkbox" onChange={this.toggleLocked} /> <span style={{ marginLeft: '5px', color: '#888', fontSize: '14px' }}>Show locked account</span>
              </div>
            </div>

            <div className='d-flex align-content-center align-items-center'>
              <div className="filter-field d-flex align-items-center">
                <label>Filter by permission</label>
                <select className="filterSelect" value={this.state.filterPermission} onChange={this.filterByPermission}>
                  <option value="">Show All</option>
                  {this.state.reportList.map(item => (
                    <option
                      key={item.key}
                      value={item.key}
                    >
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className='cron-filter filter-field d-flex align-items-center ms-3'>
                <label className='cron-label'>Select cron job</label>
                <select className="cron-select filterSelect" value={this.state.cronJob} onChange={e => this.onSelectCronJob(e.target.value)}>
                  <option value="">Select</option>
                  {this.cronsList.map((cron, ix) => (<option key={ix + 1} value={cron}>
                    {cron}
                  </option>))}
                </select>
              </div>
              <button className="btn run-btn ms-3 py-0" onClick={this.runCronJob} disabled={!this.state.cronJob}>
                Run
              </button>
            </div>


          </div>
          <div className="clients_grid">
            <Grid
              frameworkComponent={this.frameworkComponents}
              columnDefs={this.state.columnDefs}
              rowData={rowData}
              onGridReady={this.onGridReady}
              height='600px'
            >

            </Grid>
          </div>

        </div>
        {isShow && (<RightSidebarView isShow={this.state.isShow} closeSidebar={this.closeSidebar} selectedRowData={this.state.selectedRowData} history={this.props.history} />)}
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer, CompaniesReducer, ClientDataReducer }) => ({ UserReducer, CompaniesReducer, ClientDataReducer });
export default connect(mapStateToProps, { editClientData, getSyncClient, runCrons, allCompanies })(ClientsView);